import { useState } from "react";

import level2 from '../assets/images/level-2.png'
import level3 from '../assets/images/level-3-10th.png'

const images = [
  level2,
  level3,
];

const Venue = () => {
   const [index, setIndex] = useState(0);
 
  const prev = () => setIndex((i) => (i === 0 ? images.length - 1 : i - 1));
  const next = () => setIndex((i) => (i === images.length - 1 ? 0 : i + 1));
 
  // swipe handling
  const [startX, setStartX] = useState(null);
  const onTouchStart = (e) => setStartX(e.touches[0].clientX);
  const onTouchEnd = (e) => {
    if (startX === null) return;
    const diff = e.changedTouches[0].clientX - startX;
    if (diff > 50) prev();
    else if (diff < -50) next();
    setStartX(null);
  };
 
 
 
  return (
    <div className="d-flex flex-column align-items-center min-vh-100 bg-light py-4">
      <div
        className="position-relative overflow-hidden rounded shadow"
        style={{ width: "100%", maxWidth: 800 }}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <img
          src={images[index]}
          alt={`Slide ${index + 1}`}
          className="img-fluid w-100 user-select-none"
          draggable={false}
        />

      </div>
 
      <button
        onClick={next}
        className="btn btn-success mt-3 px-4"
        style={{ width: "fit-content" }}
      >
        {index == 0 ?
            <span className="text-white">See Level 3</span>
            :
            <span className="text-white">See Level 2</span>
        }
      </button>
    </div>
  );
}



export default Venue;